import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2614e018"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "splash" }
const _hoisted_2 = {
  key: 0,
  class: "alert danger"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "alert-title" }, "Alerte maintenance"),
  /*#__PURE__*/_createElementVNode("div", { class: "alert-description" }, "Launcher désactivé")
], -1))
const _hoisted_4 = {
  key: 1,
  class: "alert warning"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "alert-title" }, "Mise à jour"),
  /*#__PURE__*/_createElementVNode("div", { class: "alert-description" }, "Update launcher")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "version" }, "Version 1.0.0", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DangerIcon = _resolveComponent("DangerIcon")!
  const _component_UpdateIcon = _resolveComponent("UpdateIcon")!
  const _component_lottie_animation = _resolveComponent("lottie-animation")!
  const _component_PalaLink = _resolveComponent("PalaLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isUnderMaintenance)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_DangerIcon),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.isUnderUpdate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_UpdateIcon),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_lottie_animation, {
      class: "lottie-player container",
      path: "logo-pgames.json",
      loop: true,
      "auto-play": true,
      width: 500,
      height: 500,
      onAnimControl: _ctx.onAnim
    }, null, 8, ["onAnimControl"]),
    _createVNode(_component_PalaLink, {
      id: "help-link",
      href: "https://paladium-pvp.fr/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Problème lors de la connexion ? ")
      ]),
      _: 1
    }),
    _hoisted_6
  ]))
}